module.exports = __webpack_public_path__ + "img/IAR4.8077df5a.png";